import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false
})
export class SearchBarComponent implements OnInit {

  @Input() searchValue;
  @Output() searchEmitter = new EventEmitter<Event>();

  constructor() {
  }

  ngOnInit() {
  }

  search(event: Event) {
    this.searchEmitter.emit(event);
  }
}
